export const enum studioConstants {
  listStudiosRequest = "LIST_STUDIOS_REQUEST",
  listStudiosSuccess = "LIST_STUDIOS_SUCCESS",
  listStudiosFailure = "LIST_STUDIOS_FAILURE",

  viewStudioRequest = "VIEW_STUDIO_REQUEST",
  viewStudioSuccess = "VIEW_STUDIO_SUCCESS",
  viewStudioFailure = "VIEW_STUDIO_FAILURE",

  updateStudioRequest = "UPDATE_STUDIO_REQUEST",
  updateStudioSuccess = "UPDATE_STUDIO_SUCCESS",
  updateStudioFailure = "UPDATE_STUDIO_FAILURE",
  
  getStudioCityRequest = "GET_STUDIO_CITY_REQUEST",
  getStudioCitySuccess = "GET_STUDIO_CITY_SUCCESS",
  getStudioCityFailure = "GET_STUDIO_CITY_FAILURE",

  deactivateStudioRequest = "DEACTIVATE_STUDIO_REQUEST",
  deactivateStudioSuccess = "DEACTIVATE_STUDIO_SUCCESS",
  deactivateStudioFailure = "DEACTIVATE_STUDIO_FAILURE",
  resetDeactivateStudio = 'RESET_DEACTIVATE_STUDIO',

  reactivateStudioRequest = "REACTIVATE_STUDIO_REQUEST",
  reactivateStudioSuccess = "REACTIVATE_STUDIO_SUCCESS",
  reactivateStudioFailure = "REACTIVATE_STUDIO_FAILURE",
  resetReactivateStudtio = 'RESET_REACTIVATE_STUDIO'
}


